// 固定翼自检
export default {
    magneticCompass: 'Magnetic compass',
    airspeedMeter: 'Airspeed meter',
    executiveAgency: 'Executive agency',
    missionLoad: 'Mission load',
    heading: 'Heading',
    calibration: 'Calibration',
    airspeed: 'Airspeed',
    cleared: 'Cleared',
    TMRA: 'The motor rotates at idle speed in turn',
    motor: 'Motor',
    AIOR: 'Automatic inspection of rudder surface in turn',
    ARL: 'Aileron roll left',
    ARR: 'Aileron roll right',
    liftingRod: 'Lifting rod',
    liftPushRod: 'Lift push rod',
    turnLeft: 'Turn left',
    turnRight: 'Turn right',
    POSC: 'POS count in flight controller',
    TAPO: 'Take a photo once',
    TPTT: 'Take photos ten times',
    SWTT: 'Start waiting to take pictures',
    SWTTP: 'Stop waiting to take photos',
    CPD: 'Clear POS data',
    tip_TMEA: 'The metal equipment around the flight controller/external magnetic compass has moved or changed. Please perform advanced calibration.',
}